'use client';
import {
    isTFilterGroupFromToProps,
    isTFilterGroupRangeProps,
    TFilterGroupProps,
} from '@/components/filtersV2/filter-group/filter-group.component.types';
import FilterGroupSlider from '@/components/filtersV2/filter-group/filter-group-slider.component';
import FilterGroupOther from '@/components/filtersV2/filter-group/filter-group-other.component';
import FilterGroupFromTo from '@/components/filtersV2/filter-group/filter-group-from-to.component';

const FilterGroup = (props: TFilterGroupProps) => {
    return (
        <>
            {isTFilterGroupRangeProps(props) && (
                <FilterGroupSlider {...props} />
            )}
            {isTFilterGroupFromToProps(props) && (
                <FilterGroupFromTo {...props} />
            )}
            {!isTFilterGroupRangeProps(props) &&
                !isTFilterGroupFromToProps(props) && (
                    <FilterGroupOther {...props} />
                )}
        </>
    );
};

export default FilterGroup;
